import BaseModel from './base.model';
import { Moment } from 'moment';

export class WarrantyClaimModel extends BaseModel {
  public accountNumber: string;
  public brand: string;
  public claimNumber: number;
  public customer: {
    address: string;
    city: string;
    country: string;
    firstName: string;
    lastName: string;
    phone: string;
    servicerEmail: string;
    state: string;
    zipCode: string;
  };
  public customerComplaint: string;
  public modelNumber: string;
  public partFailedDate: Moment;
  public partInstalledDate: Moment;
  public serialNumber: string;
  public warrantyClaimDetails: IWarrantyClaimDetails[] = [];
}

export interface IWarrantyClaimDetails {
  invoiceNumber: number;
  partNumber: string;
  price: number;
  quantity: number;
  referenceNumber: string;
}

export default WarrantyClaimModel;
